(() => {
  if (window.baTokyoCountdown) {
    window.baTokyoCountdown.mountAll();
    return;
  }

  const instances = new Map();
  const selector = '[data-ba-live-countdown]';
  const parseDate = (value) => {
    const parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:Z|([+-])(\d{2}):(\d{2}))$/.exec(value);
    if (!parts) return NaN;
    const [, y, mo, d, h, mi, s = '0', , oh = '0', om = '0'] = parts;
    const year = Number(y);
    const month = Number(mo);
    const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const monthDays = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month < 1 || month > 12 || Number(d) < 1 || Number(d) > monthDays[month - 1]
      || Number(h) > 23 || Number(mi) > 59 || Number(s) > 59 || Number(oh) > 23 || Number(om) > 59) return NaN;
    return Date.parse(value);
  };

  const unmount = (root) => {
    const instance = instances.get(root);
    if (!instance) return;
    if (instance.timer !== null) window.clearInterval(instance.timer);
    if (instance.observer) instance.observer.disconnect();
    instances.delete(root);
    delete root.dataset.countdownMounted;
  };

  const mount = (root) => {
    if (instances.has(root)) return;
    const instance = { timer: null, observer: null };
    instances.set(root, instance);
    root.dataset.countdownMounted = 'true';
    const fallback = root.querySelector('[data-ba-countdown-fallback]');
    const native = root.querySelector('[data-ba-countdown-native]');
    const apps = root.querySelector('[data-ba-countdown-apps]');
    const liveAt = (root.dataset.liveAt || '').trim();
    const showPanel = (visible) => { root.hidden = !visible; };
    showPanel(false);

    if (liveAt) {
      const target = parseDate(liveAt);
      if (apps) apps.hidden = true;
      const expired = () => {
        if (native) native.hidden = true;
        if (fallback) fallback.hidden = true;
        showPanel(false);
        if (instance.timer !== null) {
          window.clearInterval(instance.timer);
          instance.timer = null;
        }
      };
      if (!Number.isFinite(target) || !native) {
        expired();
        return;
      }
      const time = root.querySelector('[data-ba-countdown-date]');
      if (time) {
        const locale = root.dataset.dateLocale || 'nb-NO';
        const date = new Intl.DateTimeFormat(locale, {
          timeZone: 'Europe/Oslo', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
        }).format(target);
        const clock = new Intl.DateTimeFormat(locale, {
          timeZone: 'Europe/Oslo', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).format(target);
        time.textContent = [date, root.dataset.timePrefix, clock, root.dataset.dateSuffix].filter(Boolean).join(' ');
      }
      const units = ['days', 'hours', 'minutes', 'seconds'].map((name) => root.querySelector(`[data-ba-countdown-unit="${name}"]`));
      const tick = () => {
        if (!root.isConnected) {
          unmount(root);
          return false;
        }
        const remaining = target - Date.now();
        if (remaining <= 0) {
          expired();
          return false;
        }
        const total = Math.ceil(remaining / 1000);
        const values = [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
        units.forEach((unit, index) => {
          if (unit) unit.textContent = String(values[index]).padStart(2, '0');
        });
        showPanel(true);
        native.hidden = false;
        if (fallback) fallback.hidden = true;
        return true;
      };
      if (tick()) instance.timer = window.setInterval(tick, 1000);
      return;
    }

    if (native) native.hidden = true;
    if (apps) apps.hidden = false;
    const updateApp = () => {
      const app = apps && apps.querySelector('.gta-block__root');
      const timer = app && app.querySelector('.gta-content__timer');
      const values = timer ? [...timer.querySelectorAll('.gta-timer__unit-value')] : [];
      let hasTimer = values.some((value) => /[1-9]/.test(value.textContent));
      for (let element = timer; element && element !== root; element = element.parentElement) {
        const style = window.getComputedStyle(element);
        if (element.hidden || style.display === 'none' || style.visibility === 'hidden') hasTimer = false;
      }
      if (fallback) fallback.hidden = true;
      showPanel(hasTimer);
    };
    updateApp();
    instance.observer = new MutationObserver(updateApp);
    instance.observer.observe(apps || root, {
      childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class', 'hidden']
    });
  };

  const mountAll = (scope = document) => {
    if (scope.matches && scope.matches(selector)) mount(scope);
    scope.querySelectorAll(selector).forEach(mount);
  };
  window.baTokyoCountdown = { mountAll };
  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((instance, root) => {
      if (event.target === root || event.target.contains(root)) unmount(root);
    });
  });
  window.addEventListener('pagehide', () => instances.forEach((instance, root) => unmount(root)));
  window.addEventListener('pageshow', () => mountAll());
  mountAll();
})();
